import { FC } from 'react';

import { IImageData } from '../../../pages/Root/services/api/interfaces.ts';
import Image from '../../../components/Image/Image.tsx';
import { Button } from '@moment/components/Button/Button.tsx';

import './GamesTile.scss';
import { useTranslation } from 'react-i18next';

interface IGamesTileProps {
  buttonText: string;
  imageList: IImageData[];
  onClick?: () => void;
  title?: string;
}

const GamesTile: FC<IGamesTileProps> = ({ buttonText, imageList, onClick, title }) => {

  const { t } = useTranslation();


  const handlePlayNow = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="games-tile" role="group" aria-label={title}>
      <h2 className="visually-hidden">{title}</h2>
      <div className="games-tile__image-container">
        <Image
          withSkeleton
          alt={title || t('game')}
          imageList={imageList}
        />
      </div>
      <Button
        className="games-tile__button"
        onClick={handlePlayNow}
        label={buttonText}
      ></Button>
    </div>
  );
};

export default GamesTile;
